<app-uni-dialog [parent]="this" [contentTemplate]="contentTemplate" [footerTemplate]="footerTemplate"></app-uni-dialog>

<ng-template #contentTemplate>
  <div uni-flex-row class="mt-2 ml-2">
    <uni-field style="width: 300px" label="Shipping Name">
      <input pInputText [ngModel]="joHeader && joHeader.shippingName" disabled />
    </uni-field>
    <uni-field style="width: 110px" label="Manifest">
      <input pInputText [ngModel]="manifest.manifestName" disabled />
    </uni-field>
    <uni-field style="width: 160px" label="Include Invoices">
      <input pInputText [ngModel]="manifest.shouldIncludeInvoices" disabled />
    </uni-field>
  </div>

  <div uni-flex-row class="mt-2 ml-2">
    <uni-field style="width: 300px" label="Billing Name">
      <input pInputText [ngModel]="joHeader && joHeader.billingName" disabled />
    </uni-field>
    <uni-field style="width: 300px" label="Invoice and Manifest Email">
      <input pInputText [(ngModel)]="emailAddress" name="emailAddress" />
    </uni-field>
  </div>

  <div *ngIf="!canPrint()" class="mt-3 ml-2" style="color: var(--p-text-muted-color)">
    This account gets manifests by email. Use the Email button.
  </div>
  <div *ngIf="isPrinting">
    If the Invoice is <b>successfully printed</b>, it can be posted to the accounting system.
  </div>
  <div *ngIf="isAccounted">
    This invoice has been sent to the accounting system.
  </div>
</ng-template>

<ng-template #footerTemplate>
  <div *ngIf="!isPrinting" class="flex flex-row gap-2">
    <button *ngIf="canPreview" pButton type="button" class="p-button-raised" (click)="showPreview()">Preview</button>
    <button pButton type="button" class="p-button-raised" [disabled]="!canSendEmail()"
      (click)="sendEmail()">Email</button>
    <button pButton type="button" class="p-button-raised" [disabled]="!canPrint()"
      (click)="printDocument()">Print</button>
    <button pButton type="button" class="p-button-raised" (click)="close()">Close</button>
  </div>
  <div *ngIf="isPrinting">
    <button pButton type="button" class="p-button-raised" (click)="isPrinting = false">Cancel</button>
  </div>

</ng-template>